const comments = [
  {
    name: '影迷小张',
    date: '2 天前',
    avatar: 'Z',
    rating: 5,
    text: '用了半年天堂影视了，画质真的顶，4K 蓝光不卡顿太香了。而且真的没有广告！之前用别的平台看到一半弹广告，烦死了。希望天堂影视越做越好，片库也越来越全。',
    movie: '肖申克的救赎',
  },
  {
    name: '周末电影控',
    date: '3 天前',
    avatar: '末',
    rating: 5,
    text: '强烈推荐给所有影迷朋友！免费还没有广告打扰，加载速度也快，手机上看同样流畅。最近把诺兰所有电影重温了一遍，体验完爆付费平台。',
    movie: '盗梦空间',
  },
  {
    name: '老电影爱好者',
    date: '4 天前',
    avatar: '老',
    rating: 4,
    text: '片库丰富程度超出预期，很多小众老电影都能找到，这点很惊喜。画质和流畅度都过关。唯一希望多加点国产老电影和经典港片，怀旧党期待更多。',
    movie: '霸王别姬',
  },
  {
    name: '理工男看电影',
    date: '5 天前',
    avatar: '理',
    rating: 5,
    text: '技术层面说一下，CDN 加速确实到位，我家 100M 宽带看 4K 毫无压力。播放器也很简洁，没有乱七八糟的功能。希望保持这种纯粹的态度。',
    movie: '星际穿越',
  },
  {
    name: '寝室观影小分队',
    date: '6 天前',
    avatar: '寝',
    rating: 5,
    text: '我们寝室四个人每周五晚上都用天堂影视一起看电影，投屏到大屏幕上效果也很好。免费高清还没有广告，宿舍观影神器！强烈安利。',
    movie: '楚门的世界',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          影迷评价
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          来自真实观影用户的评价与反馈
        </p>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-secondary-700">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                      <span className="text-xs text-foreground-500">{comment.date}</span>
                    </div>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, j) => (
                        <i
                          key={j}
                          className={`text-xs ${j < comment.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {comment.text}
                  </p>
                  <p className="mt-2 text-xs text-foreground-500">
                    正在看《{comment.movie}》
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}